module.exports = __webpack_public_path__ + "img/Frente-7-01 on.7997c70b.png";